import { render, staticRenderFns } from "./ParaEditor.vue?vue&type=template&id=54aea296&"
import script from "./ParaEditor.vue?vue&type=script&lang=js&"
export * from "./ParaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports